module.exports = __webpack_public_path__ + "img/page.1afaf295.png";